import { Link, Outlet } from "react-router-dom";
import type { User } from "../App";
import { api } from "../api";
import { DisplayTimeZoneProvider } from "../displayTimezone";

export default function Layout({
  user,
  onLogout,
}: {
  user: User;
  onLogout: () => void;
}) {
  async function logout() {
    await api("/api/auth/logout", { method: "POST", body: "{}" });
    onLogout();
  }

  return (
    <div className="layout">
      <header className="layout-header">
        <Link to="/record" className="brand">
          <span className="brand-mark">HAB</span>
          <span className="brand-sub">LOG</span>
        </Link>
        <nav className="nav">
          <Link to="/record">Record</Link>
          <Link to="/library">Library</Link>
          <Link to="/search">Search</Link>
          <Link to="/account">Account</Link>
          <button type="button" className="btn btn-ghost" onClick={() => logout()}>
            Sign out
          </button>
        </nav>
      </header>
      <main className="layout-main">
        <DisplayTimeZoneProvider timeZone={user.displayTimezone}>
          <Outlet />
        </DisplayTimeZoneProvider>
      </main>
      <footer className="layout-footer">
        <div className="layout-footer__inner">
          <p className="layout-footer__tagline">
            <span className="footer-glyph" aria-hidden>
              ◈
            </span>
            Encrypted session · private cloud neural index
          </p>
          <p className="layout-footer__meta">
            © {new Date().getFullYear()} HAB LOG ·{" "}
            <Link to="/terms">Terms</Link>
            {" · "}
            <Link to="/privacy">Privacy</Link>
          </p>
        </div>
      </footer>
    </div>
  );
}
